import React from 'react';

interface AgentCardProps {
  children: React.ReactNode;
}

const AgentCard: React.FC<AgentCardProps> = ({ children }) => {
  return (
    <div className='w-full md:w-30 h-auto max-w-md relative flex flex-col flex-wrap py-8 px-4 border border-gray-200 rounded'>
      {children}
    </div>
  );
};

export default AgentCard;
